<fc-platform-navigation *ngIf="!mobileView" [menuList]="menuList"> </fc-platform-navigation>
